const channelLabels = Object.freeze({
  ios_push: 'CampaignForm_ChannelsSelect_MobilePushIos',
  android_push: 'CampaignForm_ChannelsSelect_MobilePushAndroid',
  web_push: 'CampaignForm_ChannelsSelect_WebPush',
  email: 'CampaignForm_ChannelsSelect_Email',
  sms: 'CampaignForm_ChannelsSelect_Sms',
  inapp: 'CampaignForm_ChannelsSelect_Inapp',
  inbox: 'CampaignForm_ChannelsSelect_Inbox',
  onsite: 'CampaignForm_ChannelsSelect_Onsite',
  webhook: 'CampaignForm_ChannelsSelect_Webhook',
  facebook: 'CampaignForm_ChannelsSelect_Facebook',
  whatsapp: 'CampaignForm_ChannelsSelect_Whatsapp'
})

const channelGroupLabels = Object.freeze({
  inapp: 'CampaignForm_ChannelsSelect_Inapp'
})

const channelIcons = Object.freeze({
  ios_push: 'channel-apple',
  android_push: 'channel-android',
  web_push: 'channel-webpush',
  email: 'channel-email',
  sms: 'channel-sms',
  inapp: 'channel-inapp',
  inbox: 'channel-inbox',
  onsite: 'channel-onsite',
  webhook: 'channel-webhook',
  facebook: 'channel-facebook',
  whatsapp: 'channel-whatsapp'
})

const channelTypes = Object.freeze({
  ios_push: 1,
  onsite: 5,
  inapp: 4,
  android_push: 2,
  web_push: 3,
  inbox: 6,
  email: 7,
  sms: 9,
  webhook: 8,
  facebook: 10,
  whatsapp: 11,
  workflow: 12,
  promotion: 13
})

const messageTypeLabels = Object.freeze({
  4: 'CampaignForm_CalculateRecipients_Channel_Inapp',
  5: 'CampaignForm_CalculateRecipients_Channel_Onsite',
  6: 'CampaignForm_CalculateRecipients_Channel_Inbox',
  7: 'CampaignForm_CalculateRecipients_Channel_Email',
  8: 'CampaignForm_CalculateRecipients_Channel_Webhook',
  9: 'CampaignForm_CalculateRecipients_Channel_Sms',
  10: 'CampaignForm_CalculateRecipients_Channel_Facebook',
  11: 'CampaignForm_CalculateRecipients_Channel_Whatsapp',
  13: 'CampaignForm_CalculateRecipients_Channel_Promotion'
})

const messageChannelLabels = Object.freeze({
  11: 'CampaignForm_CalculateRecipients_Channel_InappIos',
  12: 'CampaignForm_CalculateRecipients_Channel_MobilePushIos',
  13: 'CampaignForm_CalculateRecipients_Channel_MobilePushSandbox',
  14: 'CampaignForm_CalculateRecipients_Channel_MobilePushIosLegacy',
  15: 'CampaignForm_CalculateRecipients_Channel_InappAndroid',
  16: 'CampaignForm_CalculateRecipients_Channel_MobilePushAndroid',
  17: 'CampaignForm_CalculateRecipients_Channel_MobilePushAndroidLegacy',
  18: 'CampaignForm_CalculateRecipients_Channel_Onsite',
  19: 'CampaignForm_CalculateRecipients_Channel_WebPushSafari',
  20: 'CampaignForm_CalculateRecipients_Channel_WebPushChrome',
  21: 'CampaignForm_CalculateRecipients_Channel_WebPushFirefox'
})

const dayOfWeekLabels = Object.freeze({
  1: 'CampaignForm_Schedule_DayOfWeek_Mon',
  2: 'CampaignForm_Schedule_DayOfWeek_Tue',
  3: 'CampaignForm_Schedule_DayOfWeek_Wed',
  4: 'CampaignForm_Schedule_DayOfWeek_Thu',
  5: 'CampaignForm_Schedule_DayOfWeek_Fri',
  6: 'CampaignForm_Schedule_DayOfWeek_Sat',
  7: 'CampaignForm_Schedule_DayOfWeek_Sun'
})

const dayOfWeekLabelsFull = Object.freeze({
  1: 'CampaignForm_Schedule_DayOfWeek_Monday',
  2: 'CampaignForm_Schedule_DayOfWeek_Tuesday',
  3: 'CampaignForm_Schedule_DayOfWeek_Wednesday',
  4: 'CampaignForm_Schedule_DayOfWeek_Thursday',
  5: 'CampaignForm_Schedule_DayOfWeek_Friday',
  6: 'CampaignForm_Schedule_DayOfWeek_Saturday',
  7: 'CampaignForm_Schedule_DayOfWeek_Sunday'
})

export {
  channelLabels,
  channelIcons,
  channelTypes,
  channelGroupLabels,
  dayOfWeekLabels,
  dayOfWeekLabelsFull,
  messageTypeLabels,
  messageChannelLabels
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/Labels.js